import './styles.scss';

window.React = require('react');
window.ReactDOM = require('react-dom');
window.bemHelper = require('react-bem-helper');
require('es6-promise').polyfill(); // needed for ie 11

module.exports = {};
;
      const elems = document.querySelectorAll('[toga=vendor]');
      [].forEach.call(elems, function(elem) {
        let props;
        try {
          props = JSON.parse(elem.getAttribute('props'));
        } catch (e) {
          props = {};
        }
        const Component = (typeof exports.default === 'undefined')
            ? module.exports
            : exports.default;
        ReactDOM.render(<Component {...props}/>, elem);
      });


// WEBPACK FOOTER //
// ./src/components/vendor/index.js